/** @jsx jsx */
import { jsx } from 'theme-ui';
import { graphql, useStaticQuery } from 'gatsby';
import Icon from '@fify.at/gatsby-theme-base/src/components/Icon/Icon';
import * as styles from './SocialMedia.styles.js';

export default function SocialMedia({ customStyles = styles }) {
  const {
    site: {
      siteMetadata: { socialMedia },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          socialMedia {
            icon
            url
            variant
          }
        }
      }
    }
  `);

  return (
    <div
      sx={{
        ...styles.SocialMediaWrapper,
      }}
    >
      {socialMedia.map(item => (
        <a
          key={item.icon}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon variant={item.variant} icon={item.icon} />
        </a>
      ))}
    </div>
  );
}
